import Avatar from './Avatar.jsx';
import Notifications from './Notifications.jsx';

export default function TopBar({
  connected, onlineCount, me, panelOpen,
  onTogglePanel, onOpenFriends, onSignIn, onOpenProfile, onCompose,
  locationStatus, onEnableLocation, onJumpToMe,
  notifications, friendCount = 0,
}) {
  return (
    <header className="topbar">
      <div className="brand">
        <span className={`brand-dot ${connected ? '' : 'off'}`} aria-hidden="true" />
        <span className="brand-lockup">
          <span className="brand-name">bluedot.chat</span>
          <span className="brand-tagline">The world is here.</span>
        </span>
        {/* The way in to both Nearby and your friends. It read as a status
            readout rather than a door, which is why the friend list was hard
            to find at all. */}
        <button
          type="button"
          className="live-count globe-count-button"
          onClick={onTogglePanel}
          aria-pressed={panelOpen}
          title="Everyone on the globe"
          aria-label="Everyone on the globe"
        >
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="9" cy="8" r="3.2" />
            <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
            <path d="M16 5.5a3 3 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-2.2-4.4" />
          </svg>
          {connected ? `${onlineCount} nearby` : 'reconnecting…'}
        </button>
        {/* Nothing asks on arrival. This is the only thing that raises the
            browser dialog. The crosshair is the map convention for "find me",
            so it needs no label. */}
        <button
          type="button"
          className={`icon-btn locate-button ${locationStatus === 'located' ? 'on' : ''}`}
          onClick={onEnableLocation}
          title={locationStatus === 'located'
            ? 'Precise location on — click to use an approximate area instead'
            : 'Use this device’s location instead of an approximate area'}
          aria-label="Precise location"
          aria-pressed={locationStatus === 'located'}
        >
          <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="7" />
            <circle cx="12" cy="12" r="2.2" fill="currentColor" stroke="none" />
            <path d="M12 1.6v3.2M12 19.2v3.2M22.4 12h-3.2M4.8 12H1.6" />
          </svg>
        </button>
        {/* Distinct from the crosshair beside it, which is about whether you
            are precisely placed at all. This one is about where the camera is,
            and it is the arrow every map uses for that. */}
        <button
          type="button"
          className="icon-btn jump-button"
          onClick={onJumpToMe}
          title="Go to where you are"
          aria-label="Go to where you are"
        >
          <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 3 3 10.5l7.5 3L13.5 21 21 3z" />
          </svg>
        </button>
      </div>

      <div className="topbar-actions">
        <button type="button" className="btn btn-primary btn-post" onClick={onCompose}>
          Post
        </button>
        {/* Your people are a place you go, not a tab you find. The bell is
            what is waiting; this is who you know. */}
        {me && (
          <button
            type="button" className="btn icon-only" onClick={onOpenFriends}
            title="Your friends" aria-label={`Your friends${friendCount ? `, ${friendCount}` : ''}`}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
              strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="9" cy="8" r="3.2" />
              <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
              <path d="M16 5.5a3 3 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-2.2-4.4" />
            </svg>
            {friendCount > 0 && <span className="count-pill">{friendCount}</span>}
          </button>
        )}
        <Notifications {...notifications} />
        {/* A real link, not a route: /about is a static page the server hands
            over directly, and it is the only thing on the domain a crawler
            can read. */}
        <a className="btn about-link" href="/about">About</a>
        {me ? (
          <button type="button" className="btn me-chip" onClick={onOpenProfile}>
            <Avatar person={me} size="sm" />
            <span className="name">{me.displayName}</span>
          </button>
        ) : (
          <button type="button" className="btn" onClick={onSignIn}>
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}
